import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ConfirmationService, MenuItem, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {SessionNames} from "../../../shared/session/session-names";
import {PageDescription} from "../../../shared/pages/page-description";
import {CCRolesType} from "../../../model/security/cc-roles-type";
import {Router} from "@angular/router";
import {CrystalClearFrontUrlExchange} from "../../../shared/pages/crystal-clear-front-url-exchange";
import {CcStorageService} from "../../../services/common/cc-storage.service";

@Component({
  selector: 'app-exchange-sidebar',
  templateUrl: './exchange-sidebar.component.html',
  styleUrls: ['./exchange-sidebar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class ExchangeSidebarComponent implements OnInit {

  sidebarToggledChange: boolean = true;

  transPartKey: string = 'page.exchange';

  menuItemsTop: MenuItem[] = [];
  menuItemsBottom: MenuItem[] = [];

  constructor(public router: Router,
              private storageService: CcStorageService,
              private translateService: TranslateService) {
  }

  ngOnInit() {
    //load from cookies
    // if (this.storageService.check(CookieNames.MENU_SIDE_BAR_MAXIMIZED)) {
    //   if (this.storageService.get(CookieNames.MENU_SIDE_BAR_MAXIMIZED) === 'true') {
    //     this.sidebarToggledChange = true;
    //   }
    // }
    const roles = JSON.parse(sessionStorage.getItem(SessionNames.USER_ROLES));
    if (roles) {
      this.menuItemsTop = [];
      CrystalClearFrontUrlExchange.URLS.forEach(value =>
        this.menuItemsTop.push(this.toMenuItem(value, roles, false))
      )
    }
  }

  SizeChanged($event) {
    // this.storageService.set(CookieNames.MENU_SIDE_BAR_MAXIMIZED, $event);
  }

  private toMenuItem(pDesc: PageDescription, roles: CCRolesType.Roles[], iconOnly: boolean, subItems: MenuItem[] = []): MenuItem {
    return PageDescription.toMenuItem(pDesc, this.translateService,
      this.router, roles, iconOnly, subItems);
  }
}
